import {
  Button,
  Card,
  CardActions,
  CardContent,
  FormControl,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  Paper,
  Snackbar,
  SnackbarContent,
} from "@material-ui/core";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import * as React from "react";
import { Footer, Header, Navigation } from "../../../shared";
import { AdministrationMenu } from "../../shared/menu/AdministrationMenu";
import { Tooltip } from "@material-ui/core";
import "./ImportSellOut.scss";
import TableImportSellOut from "./TableImportSellOut";
import { useEffect, useState } from "react";
import Rest from "src/services/Rest";
import ImportSellOutStatus from "./importSellOutStatus";
import FileUtils from "src/services/FileUtils";
import { getError } from "../../../../services/ErrorService";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";

function ImportSellOut() {
  const [file, setStateFile] = useState<File | undefined>(undefined);
  const [loading, setSateLoading] = useState<boolean>(false);
  const [listImports, setStateListImports] = useState([]);
  const [filters, setStateFilters] = useState({ size: 10, page: 0, total: 0 });
  const [alert, setStateAlert] = useState({
    message: "",
    open: false,
    type: "",
  });

  const styles = {
    textField: {
      marginLeft: 5,
      marginRight: 5,
    },
  };

  const handleChangeFile = (event: any) => {
    const files = event.target.files;
    if (files && files && files !== undefined) {
      setStateFile(files[0]);
    }
  };

  const openAlert = (msg: string, tipo: string) => {
    const item = { message: msg, type: tipo, open: true };
    setStateAlert(item);
  };

  const closeAlert = () => {
    const item = { message: "", type: "", open: false };
    setStateAlert(item);
  };

  const downloadPlanilha = (item: any) => {
    const patch = `planilha/${item.id}`;
    downloadSheet(patch);
  };

  const downloadLog = (item: any) => {
    const patch = `log/${item.id}`;
    downloadSheet(patch);
  };

  const columns = [
    {
      render: (item: any) => <span>{item.nome}</span>,
      title: "Nome",
    },

    {
      render: (item: any) => <span>{item.dtacriacao}</span>,
      title: "Data Solicitação",
    },
    
    {
      render: (item: any) => <span>{item.dtaalteracao}</span>,
      title: "Data Processamento",
    },
    {
      render: (item: any) => <ImportSellOutStatus status={item.status} />,
      title: "Status",
    },
    {
      render: (item: any) => (
        <>
          <IconButton
            component={"span"}
            onClick={() => downloadPlanilha(item)}
            className="filter-dialog-close"
            color="primary"
          >
            <Tooltip title="Download Planilha">
              <CloudDownloadIcon />
            </Tooltip>
          </IconButton>
          {item && item.status === "ERROR" && (
            <IconButton
              component={"span"}
              onClick={() => downloadLog(item)}
              className="filter-dialog-close"
              color="secondary"
            >
              <Tooltip title="Download Log">
                <CloudDownloadIcon />
              </Tooltip>
            </IconButton>
          )}
        </>
      ),
      title: "Ações",
    },
  ];

  const downloadSheet = (baseName: string) => {
    Rest.GET("sellout-import", baseName).then((response) => {
      if (response.ok && response.body) {
        FileUtils.downloadXlsx(response.body, decodeURIComponent(baseName));
      } else {
        openAlert(
          "O arquivo solicitado não encontra-se mais disponível",
          "error"
        );
      }
    });
  };

  const search = async (filtro: any) => {
    setSateLoading(true);
    const endPoint = `sellout-import?page=${filtro.page}&size=${filtro.size}`;
    await Rest.GET(endPoint, null)
      .then((response) => response.json())
      .then((result: any) => {
        if (result && result.error) {
          const erro = getError(result.error);
          openAlert(erro.message, "erro");
        } else {
          setStateListImports(result.dados);
          const params = {
            page: filtro.page,
            size: filtro.size,
            total: result.count,
          };
          setStateFilters(params);
        }
        setSateLoading(false);
      });
  };
  const handleChangePage = (ev: any, pageParam: number) => {
    const params = {
      page: pageParam,
      size: filters.size,
      total: filters.total,
    };
    search(params);
  };

  const salvar = async () => {
    try {
      if (file === undefined || file.name === undefined) {
        return;
      }
      const formData = new FormData();
      formData.append("file", file);
      const response = await Rest.PostBody("sellout-import", formData);
      if (response) {
        setStateFile(undefined);
        search(filters);
        openAlert("Importação Realizada com sucesso.", "success");
      }
    } catch (error) {
      const erro = getError(error);
      openAlert(erro.message, "erro");
    }
  };

  useEffect(() => {
    search(filters);
  }, []);

  return (
    <div className="import-sell-out-page">
      <Header
        title={"Importação Sell-Out"}
        name={"Administrativo"}
        link={"/dashboard"}
      />

      <Navigation
        name={"Importação de Sell-Out"}
        linkDefault={"/administration/import-sell-out"}
        link={"/dashboard"}
        linkTitle={"Produtos"}
        painel={3}
        icon={<CloudUploadIcon />}
      />

      <div className="import-sell-out-body">
        <AdministrationMenu paramIcon={null} />

        <div className="wrapper">
          <Grid container={true} className="panel-grid" spacing={16}>
            <Grid item={true} xs={12}>
              <div>
                <Paper className="analytical-panel">
                  <Grid container={true} direction="column" spacing={16}>
                    <Grid item={true}>
                      <Card>
                        <CardContent>
                          <Snackbar
                            anchorOrigin={{
                              horizontal: "center",
                              vertical: "center",
                            }}
                            open={alert.open}
                            autoHideDuration={4000}
                            onClose={closeAlert}
                          >
                            <SnackbarContent
                              message={alert.message}
                              style={styles[alert.type]}
                            />
                          </Snackbar>
                          <form autoComplete="off">
                            <FormGroup className="search-bar" row={true}>
                              <FormControl className="half-width">
                                <InputLabel htmlFor="file-input">
                                  <IconButton
                                    component={"span"}
                                    color="primary"
                                  >
                                    <Tooltip title="Importar Arquivo Sell Out">
                                      <CloudUploadIcon />
                                    </Tooltip>
                                  </IconButton>
                                  <span>
                                    {file && file.name ? file.name : ""}
                                  </span>
                                </InputLabel>
                                <input
                                  id="file-input"
                                  type="file"
                                  accept=".xlsx"
                                  multiple={false}
                                  onChange={handleChangeFile}
                                />
                              </FormControl>
                            </FormGroup>
                          </form>
                        </CardContent>
                        <CardActions>
                          <Button
                            onClick={() => setStateFile(undefined)}
                            className="filter-dialog-close"
                            color="secondary"
                            disabled={!file}
                          >
                            Cancelar
                          </Button>
                          <Button
                            onClick={salvar}
                            className="filter-dialog-close"
                            color="primary"
                            disabled={!file}
                          >
                            Salvar
                          </Button>
                        </CardActions>
                      </Card>
                      <Card>
                        <CardContent>
                          <TableImportSellOut
                            loading={loading}
                            rows={listImports}
                            columns={columns}
                            handleChangePage={handleChangePage}
                            tableProps={{
                              limit: filters.size,
                              page: filters.page,
                              total: filters.total,
                            }}
                          />
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Paper>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ImportSellOut;



// WEBPACK FOOTER //
// ./src/component/administration/registers/import-sell-out/ImportSellOut.tsx